/** Keys for user import channel selection (UI + type safety). */
export type UserImportSflag = 'email_only' | 'sms_only' | 'both';
export type UserImportTemplate = 'urgent' | 'ecw' | 'emr';

/**
 * Placeholder: string sent as multipart field `mode` on POST /users/import.
 * Values must match the backend contract — change the right-hand side when the API is finalized.
 */
export const USER_IMPORT_SFLAG_API_VALUE: Record<UserImportSflag, string> = {
  email_only: 'email_only',
  sms_only: 'sms_only',
  both: 'both',
};

export const USER_IMPORT_NOTIFICATION_OPTIONS: ReadonlyArray<{ value: UserImportSflag; label: string }> = [
  { value: 'email_only', label: 'Email only' },
  { value: 'sms_only', label: 'SMS only' },
  { value: 'both', label: 'Both' },
];

export const USER_IMPORT_TEMPLATE_OPTIONS: ReadonlyArray<{ value: UserImportTemplate; label: string }> = [
  { value: 'emr', label: 'EMR' },
  { value: 'ecw', label: 'ECW' },
  { value: 'urgent', label: 'Urgent' },

];
